var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('choose-component-transform-or-link',{attrs:{"items":_vm.buttons,"show-done":true},on:{"next":function($event){return _vm.$emit("next")},"select":_vm.onSelect}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }